import { createFileRoute } from "@tanstack/react-router"
import { createProcedureTypeViewStaticData } from "src/views/CreateProcedureTypeView/constants"
import { CreateProcedureTypeView } from "src/views/CreateProcedureTypeView/CreateProcedureTypeView"

export const Route = createFileRoute("/_loggedIn/$organizationId/_map/_layout/settings/procedure-types/create")({
	component: CreateProcedureTypeView,
	staticData: createProcedureTypeViewStaticData,
})
